import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { AppIcons } from '../assets/images/Icons';
import { CheckboxInput, CheckboxLabel } from '../styles/Checkbox';

// Note: keeping this prop type separate to Radio Button to allow future props such as indeterminate
type CheckboxProps = {
  id: string;
  name?: string;
  selected?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox: FunctionComponent<CheckboxProps> = (props) => {
  const { children, selected, id, onChange, name } = props;

  return (
    <Label htmlFor={id} data-test={`checkbox${id}`} checkboxInnerIcon={AppIcons.tickIcon}>
      <CheckboxIcon checkboxInnerIcon={AppIcons.tickIcon} selected={selected} />
      <CheckboxInput type="checkbox" name={name} onChange={onChange} id={id} checked={selected} />
      {children}
    </Label>
  );
};

const Label = styled(CheckboxLabel)<{ checkboxInnerIcon: string }>`
  /* Checkbox */
  position: relative;
`;

const CheckboxIcon = styled.span<{
  checkboxInnerIcon: string;
  selected?: boolean;
}>`
  height: ${({ theme }) => theme.spacing._24px};
  width: ${({ theme }) => theme.spacing._24px};
  border-radius: 50%;
  border: 1px solid ${Color.decorative.default};
  background-position: center;
  border: 1px solid ${Color.state.select};
  margin-right: ${({ theme }) => theme.spacing._8px};
  background-color: ${Color.surface.default};
  background-image: url(${({ selected, checkboxInnerIcon }) =>
    selected ? checkboxInnerIcon : ''});
`;
